import { fromJS } from 'immutable'
import React from 'react'
import { getStorageValue, setStorageValue, StorageFieldDefaults, StorageFields } from '../../../../storage/browserStorage'
import { NotificationPermissionStatus, requestNotificationPermissions } from '../../../../ui/notifications'
import Button from '../../../common/button'

/**
 * @param table
 * @param send
 */
class Settings extends React.Component
{

    constructor(props)
    {
        super(props)
        this.state = {
            isFullscreen: !!document.fullscreenElement,
            notificationPermissionStatus: NotificationPermissionStatus.PENDING
        }

        document.onfullscreenchange = evt => {
            this.setState({ isFullscreen: document.fullscreenElement != null })
        }
    }

    componentWillMount()
    {
        requestNotificationPermissions(result => this.setState({ notificationPermissionStatus: result }))
    }

    handleToggleFullscreen()
    {
        if (document.fullscreenElement != null) {
            document.exitFullscreen()
        } else {
            document.body.requestFullscreen()
        }
    }

    render()
    {
        const cardStyle = getStorageValue(StorageFields.CARD_STYLE) || "alt"
        const backgroundStyle = getStorageValue(StorageFields.BACKGROUND_STYLE) || "fsr"
        const fadeMenu = getStorageValue(StorageFields.FADE_MENU) || StorageFieldDefaults[StorageFields.FADE_MENU]
        const allowChat = getStorageValue(StorageFields.ALLOW_CHAT) || StorageFieldDefaults[StorageFields.ALLOW_CHAT]
        const preMoves = getStorageValue(StorageFields.PRE_MOVES) || StorageFieldDefaults[StorageFields.PRE_MOVES]

        return (
            <div className="settings">
                <div className="heading">{ Messages("table.settings.cards") }</div>
                <Button
                    text={ Messages("table.settings.cards-" + cardStyle) }
                    onClick={ () => {
                        setStorageValue(StorageFields.CARD_STYLE, cardStyle === "alt" ? "default" : "alt")
                        window._forceUpdateRootComponent()
                    } }
                />
                <div className="heading" style={{ marginTop: 15 }}>{ Messages("table.settings.background") }</div>
                <Button
                    text={ Messages("table.settings.background-" + backgroundStyle)
                        + " (" + (BackgroundStyles.indexOf(backgroundStyle) + 1) + "/" + BackgroundStyles.length + ")" }
                    onClick={ () => {
                        const nextStyle = BackgroundStyles.indexOf(backgroundStyle) == (BackgroundStyles.length - 1)
                            ? BackgroundStyles[0]
                            : BackgroundStyles[BackgroundStyles.indexOf(backgroundStyle) + 1]
                        setStorageValue(StorageFields.BACKGROUND_STYLE, nextStyle)
                        window._forceUpdateRootComponent()
                    } }
                />
                <div className="heading" style={{ marginTop: 15 }}>{ Messages("table.settings.fullscreen") }</div>
                <Button
                    disabled={ typeof document.body.requestFullscreen !== "function" }
                    text={ Messages("table.settings.fullscreen-" + this.state.isFullscreen) }
                    onClick={ this.handleToggleFullscreen.bind(this) }
                />
                <div className="heading" style={{ marginTop: 15 }}>{ Messages("table.settings.fade-menu") }</div>
                <Button
                    text={ Messages("table.settings.fade-menu." + fadeMenu) }
                    onClick={ () => {
                        setStorageValue(StorageFields.FADE_MENU, fadeMenu == "true" ? "false" : "true")
                        window._forceUpdateRootComponent()
                    } }
                />
                <div className="heading" style={{ marginTop: 15 }}>{ Messages("table.settings.pre-moves") }</div>
                <Button
                    text={ Messages("table.settings.pre-moves." + preMoves) }
                    onClick={ () => {
                        const PreMoveOptions = [ "instant", "natural", "none" ]
                        const next = PreMoveOptions.indexOf(preMoves) == (PreMoveOptions.length - 1)
                            ? PreMoveOptions[0]
                            : PreMoveOptions[PreMoveOptions.indexOf(preMoves) + 1]
                        setStorageValue(StorageFields.PRE_MOVES, next)
                        window._forceUpdateRootComponent()
                    } }
                />
                <div className="heading" style={{ marginTop: 15 }}>{ Messages("table.settings.allow-chat") }</div>
                <Button
                    text={ Messages("table.settings.allow-chat." + allowChat) }
                    onClick={ () => {
                        const AllowChatOptions = [ "everyone", "playing", "nobody" ]
                        const next = AllowChatOptions.indexOf(allowChat) == (AllowChatOptions.length - 1)
                            ? AllowChatOptions[0]
                            : AllowChatOptions[AllowChatOptions.indexOf(allowChat) + 1]
                        setStorageValue(StorageFields.ALLOW_CHAT, next)
                        window._forceUpdateRootComponent()
                    } }
                />
                <div className="heading" style={{ marginTop: 15 }}>{ Messages("table.settings.notifications") }</div>
                <Button
                    disabled
                    text={ Messages("table.settings.notifications-" + this.state.notificationPermissionStatus.toLocaleLowerCase()) }
                />
            </div>
        )
    }

}

const BackgroundStyles = [ "wood", "schwarzwald", "fsr", "geomatikum", "geomatikum-wanne", "geomatikum-wanne-alt", "oberwolfach" ]

export default Settings
export { Settings }